import { useCallback, useEffect, useState } from 'react';
import { fetchMetaFunnelDaily, type MetaFunnelRow } from '@/services/metaPixel';

// Carga los conteos diarios del embudo de Meta (últimos N días) para el panel
// admin. Expone `refetch` para el refresco manual y el auto-refresco.
export function useMetaFunnel(days = 7) {
  const [data, setData] = useState<MetaFunnelRow[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    fetchMetaFunnelDaily(days)
      .then((rows) => {
        if (cancelled) return;
        setData(rows);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err instanceof Error ? err.message : 'Error al cargar el embudo');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [days]);

  useEffect(() => load(), [load]);

  return { data, loading, error, refetch: load };
}